import { render, staticRenderFns } from "./CuiNotice.vue?vue&type=template&id=7d22edb2&scoped=true"
import script from "./CuiNotice.vue?vue&type=script&lang=js"
export * from "./CuiNotice.vue?vue&type=script&lang=js"
import style0 from "./CuiNotice.vue?vue&type=style&index=0&id=7d22edb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d22edb2",
  null
  
)

export default component.exports